import { connectedStore } from '../../store';
import cssGenerator from '../../css-generator';
import setResponsiveAttributeAction from '../actions/set-responsive-attribute';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const setResponsiveAttribute = (
  elementId,
  attr,
  value,
  breakpoint = cssGenerator.constants.breakpointNames.EMPTY,
  options
) => {
  const store = connectedStore.get();
  store.dispatch(setResponsiveAttributeAction(elementId, attr, value, breakpoint, options));
};

setResponsiveAttribute[USED_ACTION_CREATOR] = setResponsiveAttributeAction;

export default setResponsiveAttribute;
